var __jsx = React.createElement;
import React from 'react';
// import PropTypes from 'prop-types'
import { Grid, CardContent, Skeleton } from '@mui/material';
import { Paper } from './style';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SectionSkeleton = function SectionSkeleton() {
  return /*#__PURE__*/_jsx(Paper, {
    variant: "outlined",
    children: /*#__PURE__*/_jsxs(CardContent, {
      children: [/*#__PURE__*/_jsx(Skeleton, {
        width: "25%",
        height: 40
      }), /*#__PURE__*/_jsx(Grid, {
        container: true,
        direction: "row",
        spacing: 3,
        children: Array.from(new Array(5)).map(function () {
          return /*#__PURE__*/_jsx(Grid, {
            item: true,
            lg: 2,
            children: /*#__PURE__*/_jsx(Skeleton, {
              height: 80
            })
          });
        })
      })]
    })
  });
};
export default SectionSkeleton;